import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';

@Component({
  selector: 'app-toggle-button',
  templateUrl: './toggle-button.component.html',
  styleUrls: ['./toggle-button.component.css']
})
export class ToggleButtonComponent implements OnInit {

  @Input() labelTrue: string = '';
  @Input() disable: boolean = false;
  @Input() labelFalse: string = '';
  @Input() selectedValue: boolean = false;
  @Input() label: string = '';
  @Output() handleToggle = new EventEmitter<boolean>();

  ngOnInit(): void {
  }

  handleClick(value) {
    if (this.selectedValue == value) {
      return;
    }
    this.selectedValue = value;
    this.handleToggle.emit(value);
  }

}
